import { combineReducers } from 'redux';

import { reducer as estimate } from './State/estimate';
import { reducer as selectedRowKeys } from './State/selectedRowKeys';

export default combineReducers({
  estimate,
  selectedRowKeys
})
